// routes/_app.404._index.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.404._index')

export const handle = { name: '404' }

export function loader() {
  return null
}

export function clientLoader() {
  return null
}
clientLoader.hydrate = true

export default dynamic(getClientModule, { ssr: false })
